import { types } from 'mobx-state-tree';

export const DeficiencyFileCount = types
  .model({
    deficiencyFileCount: types.maybeNull(types.number),
  })
  .views(self => ({
    get getDeficiencyFileCount() {
      return self.deficiencyFileCount;
    },
  }))
  .actions(self => ({
    setDefFileCount: (count: number) => {
      self.deficiencyFileCount = count;
    },
    decreaseDefFileCount: () => {
      if (self.deficiencyFileCount) {
        self.deficiencyFileCount = self.deficiencyFileCount - 1;
      }
    },
  }));

export default DeficiencyFileCount;
